import { useMusic } from "@/contexts/MusicContext";
import { useSponsorInfo } from "@/hooks/useSponsorInfo";
import { useAudioControls } from "./useAudioControls";
import { usePreviewMode } from "./usePreviewMode";
import { useStreamHandling } from "./useStreamHandling";

export function useMusicPlayer() {
  const { currentTrack, isPlaying, setIsPlaying } = useMusic();

  // Fetch sponsor info if track is sponsored
  const { data: sponsorData } = useSponsorInfo(
    currentTrack?.sponsorId,
    currentTrack?.isSponsored || false,
  );

  // Audio controls (playback, volume, seeking, time)
  const {
    currentTime,
    volume,
    isActuallyPlaying,
    setIsActuallyPlaying,
    audioRef,
    handleTimeUpdate,
    handleSeek,
    handleVolumeChange,
    formatTime,
  } = useAudioControls({
    currentTrack,
    isPlaying,
    setIsPlaying,
  });

  // Preview mode logic
  const { isPreviewMode, enablePreviewMode, disablePreviewMode } =
    usePreviewMode({
      currentTrack,
      isPlaying,
      setIsPlaying,
      audioRef,
      currentTime,
    });

  // Stream handling (likes, completion)
  const { liked, toggleLike, handleStreamComplete } = useStreamHandling({
    currentTrack,
  });

  return {
    currentTrack,
    isPlaying,
    isActuallyPlaying,
    setIsActuallyPlaying,
    currentTime,
    volume,
    liked,
    audioRef,
    sponsorData,
    isPreviewMode,
    handleTimeUpdate,
    handleSeek,
    handleVolumeChange,
    toggleLike,
    formatTime,
    handleStreamComplete,
    enablePreviewMode,
    disablePreviewMode,
    setIsPlaying,
  };
}
